const React = require('react');

const Padded = ({ children }) => <div className="modal-padded">{children}</div>;

export default Padded;
